import React from "react";
import styled from "styled-components";

const StyledInput = styled.div`
  input {
    width: 100%;
    border: 1px solid ${props => props.theme.colors.gray1};
    padding: 0.5rem 0.25rem;
  }

  &.size-s input {
    font-size: 0.9rem;
  }

  &.size-m input {
    font-size: 1rem;
  }

  &.size-l input {
    font-size: 1.1rem;
  }
`;

interface Props extends React.HTMLProps<HTMLInputElement> {
  inputSize?: "s" | "m" | "l";
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Input: React.FC<Props> = ({ inputSize = "m", ...props }) => {
  return (
    <StyledInput className={`size-${inputSize}`}>
      <input {...props} />
    </StyledInput>
  );
};

export default Input;
